<template>
     <div class="">
        <!-- IMPRESION TICKET DE COMPRA -->
        <vue-html2pdf
          :show-layout="false"
          :float-layout="true"
          :enable-download="false"
          :preview-modal="true"
          :filename="`Ticket de compra-${ticket}`"
          :pdf-quality="2"
          :manual-pagination="true"
          :paginate-elements-by-height="1400"
          :htmlToPdfOptions = "htmlToPdfOptions"
          pdf-format="b6"
          pdf-orientation="portrait"
          pdf-content-width="100%"
          @progress="onProgress($event)"
          @startPagination="startPagination()"
          @hasPaginated="hasPaginated()"
          @hasGenerated="hasGenerated($event)"
          ref="html2Pdf"
        >
        <section slot="pdf-content" style="width: 75mm !important;">
            <div class="container ticket" style="width: 75mm !important">
              <div class="row justify-content-center">
                <div class="mt-4 col-lg-10 text-center line1">
                  <p><b>Ticket de compra</b></p>
                </div>
              </div>
              <div class="mt-2 col-lg-10 text-center">
                <p><b>{{ enterprise }}</b></p>
              </div>
              <div class="mt-1 ml-3 bodyLineHeigth line1 detailFront">
                <label>Folio: {{ultimaVenta.generals !== undefined ? ultimaVenta.generals.invoice : 0 }}</label>
                <br>
                <label>Fecha: {{ultimaVenta.generals !== undefined ? ultimaVenta.generals.date: ''}}</label>
                <br>
                <label>Cliente:
                <br>
                {{ultimaVenta.generals !== undefined ? ultimaVenta.rows[0].name_client : ''}}</label>
                <br>
                <label>ATENDIO: {{user.name + ' ' + user.last_name_1 + ' ' + user.last_name_2}}</label>
              </div>
            </div>
            <div class="mt-2 text-center line1">
              Total de productos: {{ultimaVenta.quantityProdcuts}}
            </div>
            <div class="row justify-content-center mt-4 bodyPrintAbono line1" style="width: 70mm !important;">
              <div class="col-lg-12">
                <table style="padding: 0px;" class="">
                  <tr class="text-center tableXD">
                    <td style="height: 5px;">Codigo<br />Desc.</td>
                    <td style="height: 5px;">Can</td>
                    <td>P/Unit.</td>
                    <td>Desc</td>
                    <td>Total</td>
                  </tr>
                  <tr class="text-right" v-for="(v, index) in ultimaVenta.rows" :key="index" style="font-size: 7px;">
                    <td class="line1 line2" style="font-size: 8px;"><b>{{v.barcode}}<br/>{{v.product}}</b></td>
                    <td class="line1 line2" style="font-size: 9px;"><b>{{ v.quantity }} </b></td>
                    <td class="line1 line2" style="font-size: 9px;"><b>{{v.precio | formatNumberCurrency}}</b></td>
                    <td class="line1 line2" style="font-size: 9px;"><b>{{v.discount_percentage}}%</b></td>
                    <td class="line1 line2" style="font-size: 9px;"><b>{{v.total | formatNumberCurrency}}</b></td>
                  </tr>
                  <tr>
                    <td colspan="2" class="text-right line1" style="font-size: 10px;">
                      TOTAL DE PRODUCTOS:
                    </td>
                    <td colspan="2" class="text-right line1" style="font-size: 10px;">
                      <b>$ {{ultimaVentaReales.totalCompra | formatNumberCurrency}}</b>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2" class="text-right line1" style="font-size: 10px;">
                      DESCUENTO:
                    </td>
                    <td colspan="2" class="text-right line1" style="font-size: 10px;">
                      <b>$ {{ultimaVenta.descuento | formatNumberCurrency}}</b>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2" class="text-right line1" style="font-size: 10px;">
                      <!-- SUBTOTAL: -->
                      TOTAL:
                    </td>
                    <td colspan="2" class="text-right line1" style="font-size: 10px;">
                      <b>$ {{(ultimaVenta.total) | formatNumberCurrency}}</b>
                    </td>
                  </tr>
                  <tr v-if="ultimaVentaReales.totalAbonos > 0">
                    <td colspan="2" class="text-right line1" style="font-size: 10px;">
                      Abonos:
                    </td>
                    <td colspan="2" class="text-right line1" style="font-size: 10px;">
                      <b>$ {{ultimaVentaReales.totalAbonos | formatNumberCurrency}}</b>
                    </td>
                  </tr>
                  <tr v-if="ultimaVentaReales.totalNotas > 0">
                    <td colspan="2" class="text-right line1" style="font-size: 10px;">
                      Notas:
                    </td>
                    <td colspan="2" class="text-right line1" style="font-size: 10px;">
                      <b>$ {{ultimaVentaReales.totalNotas | formatNumberCurrency}}</b>
                    </td>
                  </tr>
                  <tr v-if="ultimaVentaReales.total_cancelaciones > 0">
                    <td colspan="2" class="text-right line1" style="font-size: 10px;">
                      Cancelaciones:
                    </td>
                    <td colspan="2" class="text-right line1" style="font-size: 10px;">
                      <b>$ {{ultimaVentaReales.total_cancelaciones | formatNumberCurrency}}</b>
                    </td>
                  </tr>
                  <!-- <tr>
                    <td colspan="2" class="text-right" style="font-size: 10px;">
                      TOTAL:
                    </td>
                    <td colspan="2" class="text-right" style="font-size: 10px;">
                      <b>$ {{(ultimaVentaReales.total - ultimaVentaReales.descuento - ultimaVentaReales.totalNotas - ultimaVentaReales.totalAbonos) | formatNumberCurrency}}</b>
                    </td>
                  </tr> -->
                </table>
              </div>
              <div class="row">
                <table class="mt-3">
                  <tr class="text-center">
                    <td colspan="2" class="text-center">
                      Detalle de Pago
                    </td>
                  </tr>
                  <tr style="font-size: 10px;" v-if="ultimaVentaReales !== undefined && ultimaVentaReales.efectivo > 0">
                    <td style="font-size: 10px;"><b>
                      Pago en Efectivo
                    </b>
                  </td>
                    <td style="font-size: 10px;"><b>
                      $ {{ultimaVentaReales === undefined ? 0 : (ultimaVentaReales.total - ultimaVentaReales.totalAbonos - ultimaVentaReales.transferencia - ultimaVentaReales.tarjeta + ultimaVentaReales.comision) | formatNumberCurrency}}
                    </b>
                  </td>
                  </tr>
                  <tr v-if="ultimaVentaReales !== undefined && ultimaVentaReales.transferencia > 0">
                    <td style="font-size: 10px;"><b>
                      Pago con transferencia
                    </b>
                    </td>
                    <td style="font-size: 10px;"><b>
                        $ {{ultimaVentaReales === undefined ? 0 : ultimaVentaReales.transferencia | formatNumberCurrency}}
                      </b>
                    </td>
                  </tr>
                  <tr v-if="ultimaVentaReales !== undefined && ultimaVentaReales.tarjeta > 0">
                    <td style="font-size: 10px;"><b>
                      Pago con tarjeta
                    </b>
                    </td>
                    <td style="font-size: 10px;"><b>
                        $ {{ultimaVentaReales === undefined ? 0 : ultimaVentaReales.tarjeta | formatNumberCurrency}}
                      </b>
                    </td>
                  </tr>
                  <tr style="font-size: 10px;" v-if="ultimaVentaReales !== undefined && ultimaVentaReales.comision > 0">
                    <td style="font-size: 10px;"><b>
                      Comisión
                    </b>
                  </td>
                    <td style="font-size: 10px;"><b>
                      $ {{ultimaVentaReales === undefined ? 0 : ultimaVentaReales.comision | formatNumberCurrency}}
                    </b>
                  </td>
                  </tr>
                  <tr style="font-size: 10px;" v-if="ultimaVentaReales !== undefined && ultimaVentaReales.efectivo > 0">
                    <td style="font-size: 10px;"><b>
                      Efectivo recibido
                    </b>
                  </td>
                    <td style="font-size: 10px;"><b>
                      $ {{ultimaVentaReales === undefined ? 0 : ultimaVentaReales.efectivo | formatNumberCurrency}}
                    </b>
                  </td>
                  </tr>
                  <tr style="font-size: 10px;" v-if="ultimaVentaReales !== undefined && ultimaVentaReales.cambio > 0">
                    <td style="font-size: 10px;"><b>
                      Cambio
                    </b>
                  </td>
                    <td style="font-size: 10px;"><b>
                      $ {{ultimaVentaReales === undefined ? 0 : ultimaVentaReales.cambio | formatNumberCurrency}}
                    </b>
                  </td>
                  </tr>
                  <tr style="font-size: 10px;" v-for="abono in ultimaVenta.abonos" :key="abono.id">
                    <td style="font-size: 10px;"><b>
                      Nota {{abono.type}}
                    </b>
                    </td>
                      <td style="font-size: 10px;"><b>
                        $ {{abono.amount | formatNumberCurrency}}
                      </b>
                    </td>
                  </tr>
                  <tr style="font-size: 10px;" v-for="abono in ultimaVenta.devoluciones" :key="abono.id">
                    <td style="font-size: 10px;"><b>
                      Vale {{abono.barcode}}
                    </b>
                    </td>
                      <td style="font-size: 10px;"><b>
                        $ {{abono.amount | formatNumberCurrency}}
                      </b>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="row justify-content-center mt-4">
              <!-- <div class="col-lg-10 text-center footerTicket line1">
                <p>Gracias por su compra</p>
                <p>Teléfonos:</p>
                <p>442 364 6862</p>
                <p>442 212 0485</p>
                <p>442 212 3268</p>
              </div> -->
              <div class="col-9 text-center footerTicket line1">
                <small>Teléfonos:</small>
                <div v-for="p in footer.phones" :key="p.phone">
                  <small>{{ p.phone }}</small> <br>
                </div>
              </div>
              <p style="font-size: 12px;">{{ this.footer.textoFooter }}</p>
            </div>
          </section>
        </vue-html2pdf>
      </div>
</template>
<script>
import VueHtml2pdf from 'vue-html2pdf'
import { mapGetters } from 'vuex'
import moment from 'moment-timezone'
import axiosAdelaService from '@/axios/axiosAdelaService'
moment().tz('America/Mexico_city').format()

export default {
  props: ['ticket', 'enterprise', 'print'],
  components: {
    VueHtml2pdf
  },
  data () {
    return {
      footer: [],
      totalProductos: 0,
      ultimaVenta: [],
      ultimaVentaReales: [],
      htmlToPdfOptions: {
        margin: [5, 0, 15, 0],
        // margin: 0,
        // image: {
        //   type: 'jpeg',
        //   quality: 0.98
        // },
        // enableLinks: false,
        html2canvas: {
          scale: 3,
          useCORS: true
        }
        // jsPDF: {
        //   unit: 'mm',
        //   format: 'b10',
        //   orientation: 'portrait'
        // }
      }
    }
  },
  watch: {
    async print () {
      await this.getFooterTicket()
      this.getSale(this.ticket)
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    }),
    horaActual () {
      return moment.utc().format('HH:mm:ss')
    }
  },
  methods: {
    async getSale (invoice) {
      console.log('entro a este pedo')
      this.ultimaVenta = []
      this.totalProductos = 0
      const request = {
        invoice: invoice,
        // invoice: 1,
        id_empresa: this.user.enterprise_id
      }
      const response = await axiosAdelaService.post('/getLastSales', request)
      console.log('getLastSales', response)
      if (response.status === 200) {
        this.ultimaVenta = response.data
        // this.ultimaVenta.generals.date = this.ultimaVenta.generals.date
        const abonos = this.ultimaVenta.abonos
        this.ultimaVentaReales = response.data.reales
        let totalVenta = 0
        let descuento = 0
        let quantityProdcuts = 0
        for (const key in this.ultimaVenta.rows) {
          console.log('ULTIMA VENTA', this.ultimaVenta.rows[key])
          totalVenta += this.ultimaVenta.rows[key].quantity * this.ultimaVenta.rows[key].precio
          descuento += this.ultimaVenta.rows[key].descuento2 === null ? (this.ultimaVenta.rows[key].quantity * this.ultimaVenta.rows[key].descuento) : this.ultimaVenta.rows[key].descuento2
          quantityProdcuts += this.ultimaVenta.rows[key].quantity
        }
        // this.ultimaVenta.rows.forEach(el => {
        //   totalVenta += el.quantity * el.precio
        //   descuento += (el.quantity * el.descuento)
        //   quantityProdcuts += el.quantity
        // })
        this.ultimaVenta.quantityProdcuts = quantityProdcuts
        this.ultimaVenta.subtotal = this.getFormattedAmount(totalVenta)
        this.ultimaVenta.descuento = this.getFormattedAmount(descuento)
        this.ultimaVenta.total = this.getFormattedAmount(totalVenta - descuento)
        this.ultimaVentaReales.totalCompra = totalVenta
        // console.log(this.$formatCurrencyToText(totalVenta - descuento))
        await this.verifyStatusAbono(abonos)
        this.$refs.html2Pdf.generatePdf()
      }
    },
    onProgress (progress) {
      this.progress = progress
      console.log(`PDF generation progress: ${progress}%`)
    },
    startPagination () {
      console.log('PDF has started pagination')
    },
    hasPaginated () {
      console.log('PDF has been paginated')
    },
    async beforeDownload ({ html2pdf, options, pdfContent }) {
      console.log('On Before PDF Generation')
    },
    hasDownloaded (blobPdf) {
      console.log('PDF has downloaded yehey')
      this.pdfDownloaded = true
      console.log(blobPdf)
    },
    getFormattedAmount (amount) {
      if (amount) {
        return '$ ' + this.$formatNumberCurrency(amount, 'MXN')
      } else {
        return ''
      }
    },
    async verifyStatusAbono (abonos) {
      const request = {
        abonos: abonos,
        id_empresa: this.user.enterprise_id
      }
      console.log('verifyStatusAbono request', request)
      const response = await axiosAdelaService.post('/verifyStatusAbono', request)
      console.log('verifyStatusAbono XXXDDD', response)
      if (response.status === 200) {
        // this.$refs.html2Pdf.generatePdf()
      }
    },
    async getFooterTicket () {
      const request = {
        enterprise_id: this.user.enterprise_id
      }
      console.log('getFootero request', request)
      const response = await axiosAdelaService.post('/getFooterTicket', request)
      console.log('verifyStatusAbono XXXDDD', response)
      if (response.status === 200) {
        this.footer = response.data
      }
    }
  }
}
</script>

<style>

.ticketTable td{
  font-size: 7px;
}
.ticketClass {
  width: 8cm;
}
/* .inputNumberClient {
  border-radius: 10px;
  border-color: red;
  text-align: center;
}
.btnAddOrder {
  border: none;
  font-size: 18px;
  border-radius: 10px;
  color: white;
}
.btnAddRow {
  font-size: 30px;
  background: #22da65;
  width: 100px;
}
.btnRegister {
  background: #227bda;
  padding: 5px;
}
.green {
  background:#1580002e;
  color:white;
}
.otherClient {
  background: #00ccfd69;
}
.red {
  background: red;
  color:white;
}
.inputBarCode {
  width: 300px;
  font-size: 20px;
  border-radius: 5px;
  border-color: blue;
  text-align: center;
}
.endRow {
    margin-right: 0%;
}
.greenChange {
  background: rgb(0, 255, 0);
  color:rgb(27, 2, 2);
} */
table, th, td {
  /* font-family: "VollkornRegular";
  src: local("VollkornRegular"),
   url(../../assets/sass/styles/fonts/VollkornRegular.ttf) format("truetype"); */
  /* font-family: Cantarell, Ticketing, Roboto, Cantarell, 'Courier New', Courier, monospace; */
  color: black;
  /* line-height: .1px !important; */
  font-weight: bolder !important;
  /* border: .1rem solid; */
  /* border: .5px solid orange; */
  border-bottom: 1pt solid black;
  border-collapse: collapse;
  font-size: 10px;
}
.footerTicket p {
  line-height: .1px;
}
.bodyLineHeigth {
  font-size: 10px;
}
.bodyLineHeigth td {
  font-size: 10px;
}

.footerTicket p {
  font-size: 8px;
  line-height: .1px !important;
}
.line1 {
  /* font-family: "VollkornRegular";
  src: local("VollkornRegular"),
   url(../../assets/sass/styles/fonts/VollkornRegular.ttf) format("truetype"); */
  /* font-family: Cantarell, Ticketing, Roboto, Cantarell, 'Courier New', Courier, monospace; */
  color: black;
  /* line-height: .1px !important; */
  font-weight: bolder !important;
  font-size: 10px !important;
}
.line2 {
  /* font-size: 8px !important; */
}
.bodyPrintAbono table {
  /* font-family: "VollkornRegular";
  src: local("VollkornRegular"),
   url(../../assets/sass/styles/fonts/VollkornRegular.ttf) format("truetype"); */
  color: black;
  font-size: 8;
  width: 100%;
}

.bodyPrintAbono td, th {
  /* border: 1px solid #dddddd; */
  text-align: left;
  padding: 8px;
}

.bodyPrintAbono tr:nth-child(even) {
  /* background-color: #dddddd; */
}
.ticket {
  /* font-family: "VollkornRegular";
  src: local("VollkornRegular"),
   url(../../assets/sass/styles/fonts/VollkornRegular.ttf) format("truetype"); */
  /* font-family: Cantarell, Ticketing, Roboto, 'Courier New', Courier, monospace; */
  color: black;
  font-size: 10px;
  font-weight: bolder !important;
}
.tableXD {
  font-weight: bolder !important;
  font-size: 10px !important;
}
.detailFront p {
  font-size: 10px;
  line-height: 16.5pt !important;
  margin-bottom: 0px !important;
  margin: 0 !important;
}
.descuentoInpit {
  padding: 0;
}
</style>
